import React, { useEffect, useRef, useState } from "react";
import "../styles/ActionMenu.css";

// A disclosure with ordinary buttons: native Tab navigation, Escape and outside dismissal.
export default function ActionMenu({ label = "More", context, children }) {
  const [open, setOpen] = useState(false);
  const container = useRef(null);
  const trigger = useRef(null);
  useEffect(() => {
    if (!open) return;
    const dismiss = (event) => {
      if (!container.current?.contains(event.target)) setOpen(false);
    };
    document.addEventListener("pointerdown", dismiss);
    return () => document.removeEventListener("pointerdown", dismiss);
  }, [open]);
  return <div className="action-disclosure" ref={container}
    onClick={(event) => event.stopPropagation()}
    onBlur={(event) => { if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false); }}
    onKeyDown={(event) => { if (event.key === "Escape") { event.preventDefault(); setOpen(false); trigger.current?.focus(); } }}>
    <button ref={trigger} type="button" className="action-disclosure-trigger" aria-label={context ? `${label} actions for ${context}` : label} aria-expanded={open} onClick={() => setOpen(!open)}>{label} <span aria-hidden="true">{open ? "−" : "⋯"}</span></button>
    {open && <div className="action-disclosure-options" onClick={(event) => {
      if (event.target.closest("button:not(:disabled), a")) { setOpen(false); trigger.current?.focus(); }
    }}>{children}</div>}
  </div>;
}
